module.exports = "//static.hsappstatic.net/salesImages/static-1.403/outlook/icons/sprocket-128.png"